import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import {
  filterBySelectedEnclosure,
  filterModelsBasedOnSelectedEnclosures, getTotalCountOfDevices,
  sumOfQuantitiesOfBomModels
} from '../../prisma-xs/helpers/bom-mapper.helper';

@Pipe({
    name: 'subProjectBomQuantities',
    standalone: false
})
export class SubProjectBomQuantitiesPipe implements PipeTransform {

  // eslint-disable-next-line max-len
  transform(selectedDevices: number[], bomModels: IBomModel[], bomModelsAccessories: IBomModel[], bomModelsProjectComponents: IBomModel[], selectedDevicesAccessories: number[], selectedDevicesProjectComponents: number[], selectedEnclosures: number[]): number {
    selectedEnclosures = [0, ...selectedEnclosures];
    return getTotalCountOfDevices(filterModelsBasedOnSelectedEnclosures(
        this.filterBySelectedDevices(bomModelsAccessories, selectedDevicesAccessories), selectedEnclosures)
      ) +
        getTotalCountOfDevices(filterModelsBasedOnSelectedEnclosures(
          this.filterBySelectedDevices(bomModels, selectedDevices), selectedEnclosures)
      ) +
      sumOfQuantitiesOfBomModels(filterBySelectedEnclosure(selectedEnclosures, bomModelsProjectComponents),
        selectedDevicesProjectComponents);
  }

  private filterBySelectedDevices(models: IBomModel[], selectedModels: number[]) {
    return models.filter(m => selectedModels.indexOf(m.article.id) > -1);
  }
}
